import axios from 'axios';

export type PriceBookVersionSummary = {
	id: string;
	name: string;
	publishedAt: string;
};

export type PriceBooksResult = {
	versions: Array<PriceBookVersionSummary>;
	/** What price_book_current points at. NOT the newest publish — an older book can be re-minted after a newer one (restoring a pre-increase baseline), and list order then names the wrong version. */
	currentVersionId: string | null;
};

export type FetchPriceBooksParams = {
	getToken: () => Promise<string>,
	limit?: number
};

export const fetchPriceBooks = async (params: FetchPriceBooksParams): Promise<[PriceBooksResult | null, string | null]> => {
	const { getToken, limit = 50 } = params;

	try {
		const token = await getToken();
		const response = await axios.get<{ versions: Array<PriceBookVersionSummary>; currentVersionId?: string | null }>(
			`${import.meta.env.VITE_API_URL}/manage/price-books?offset=0&limit=${limit}`,
			{ headers: { Authorization: `Bearer ${token}` } }
		);

		const versions = response.data.versions ?? [];

		// Never fall back to the newest publish. Absent or null both mean "nothing is current", and the
		// honest answer is the live catalog — guessing a book here silently prices designs against it.
		return [{ versions, currentVersionId: response.data.currentVersionId ?? null }, null];
	} catch {
		return [null, 'Failed to fetch price book versions'];
	}
};
